import { Card } from "./Card";
import { Suit } from './Suit';
import { Hand } from './Hand';

export interface CardOptions {
    minNumber?: number;
    maxNumber?: number;
    suits?: Suit[];
    shuffle?: boolean;
}

export class Deck {
    cards: Card[] = [];
    hands: Hand[] = [];

    dealIndex: number = 0;

    constructor(options: CardOptions = {}) {
        if (!options.minNumber) {
            options.minNumber = 1;
        }

        if (!options.maxNumber) {
            options.maxNumber = 13;
        }

        if (!options.suits) {
            options.suits = [Suit.Hearts, Suit.Diamonds, Suit.Clubs, Suit.Spades];
        }

        if (options.shuffle === undefined) {
            options.shuffle = true;
        }

        for (const suit of options.suits) {
            for (let i = options.minNumber; i <= options.maxNumber; i++) {
                this.cards.push(new Card(suit, i));
            }
        }

        if (options.shuffle) {
            this.shuffle();
        }
    }

    draw (): Card {
        const card = this.cards[this.dealIndex];
        this.dealIndex++;
        return card;
    }

    deal(hand: Hand, numCards: number = 7): Hand {
        for (let i = 0; i < numCards; i++) {
            const card = this.draw();
            card.player = hand.index;
            card.location = hand.index-1;
            hand.cards.push(card);
        }
        return hand;
    }

    discardRemaining () {
        this.cards = this.cards.splice(0, this.dealIndex - 1);
    }

    shuffle() {
        let currentIndex = this.cards.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = this.cards[currentIndex];
            this.cards[currentIndex] = this.cards[randomIndex];
            this.cards[randomIndex] = temporaryValue;
        }

        return this.cards;
    }

}



// WEBPACK FOOTER //
// ./src/playing-cards/Deck.ts